import { signal } from 'services/SignalsService'
import { Device } from 'utils/Device'

export function enableResize(object, settings) {
  signal.on('RESIZE', function ({ orientation, scale, stage, screen }) {
    object.visibility(!!settings[orientation], 'orientation')
    object.scale.set(doScale(object, scale, screen))

    object.x = (stage.width - object.width) / 2
    object.y = (stage.height - object.height) / 2
  })

  return object
}

export function enableSpineResize(object) {
  signal.on('RESIZE', function ({ scale, stage, screen }) {
    if(Device.isDesktop()){
      object.scale.set(doScale(object, scale, screen))

      object.x = ((stage.width - object.width) / 2) + object.width / 2
      object.y = ((stage.height - object.height) / 2) + object.height / 2
    }
    else {
      object.scale.set(doScale(object, scale, screen) * 2)

      object.x = (((stage.width - object.width) / 2) + object.width / 2) * 2
      object.y = (((stage.height - object.height) / 2) + object.height / 2) * 2
    }

  })

  return object
}

function doScale(object, scale, screen) {
  object.scale.set(scale)

  return Math.max(screen.width / object.width, screen.height / object.height)
}
